import React, { useState, useEffect } from 'react'
import EditUserDetailsNew from './EditUserDetailsNew.container';
import Loader from '../../../../../presentationals/Loader/Loader.component'
import KarzaPOPUPUI from '../../../../../presentationals/Popup/KarzaPopup.component'
import AAdharPopup from '../../../../../presentationals/Popup/KarzaAddharPopup.component'
import Popup from '../../../../../presentationals/Popup/Popup.component'
import { getAllUserDetailsIncompleteByUserId, panProfileDetails, aadharXmlData, aadharXmlDetails, getDocumentByUserId } from '../../../AdminActionCreator.component';
import EditPersonalDetail from './EditPersonalDetail';
import EditBasicDetail from './EditBasicDetail';
import EditCurrentAddressDetail from './EditCurrentAddressDetail'
import EditPermanentAddressDetail from './EditPermanentAddressDetail'
import EditAssetVehicleDetail from './EditAssetVehicleDetail';
import EditEmploymentDetail from './EditEmploymentDetail';
import EditAccountDetail from './EditAccountDetail';
import EditDouemntsDetails from './EditDocumentDetail'
const customStylePopup = {
    zIndex: '9'
}

const currenPage = 1;
const totalItems = 20;

export default function Main({ userDetails, viewType }) {
    const [loader, setLoader] = useState(false)
    const [popups, setpopups] = useState({ show: false, popupStatus: '' })
    const [allData, setAllData] = useState({})
    const [panPopup, setPanPopup] = useState(false)
    const [panData, setpanData] = useState({})
    const [aadhaarPopup, setAadhaarPopup] = useState(false)
    const [aadhaarData, setaadhaarData] = useState({})
    const [aadhaarAddressData, setaadhaarAddressData] = useState("")
    const [aadhaarAddressPopupData, setaadhaarAddressPopupData] = useState("")
    const [verificationType, setverificationType] = useState("")
    const [documentData, setDocumentData] = useState([])
    const [selectedDocument, setSelectedDocument] = useState({})
    const [allDocuments, setallDocuments] = useState([])
    const [editdata, setEditData] = useState({ show: false, type: "", data: {} })

    useEffect(() => {
        ApicallFn()
    }, [])

    const ApicallFn = () => {
        getAllUserDetailsIncompleteByUserIdFn(userDetails)
        panProfileDetailsFn(userDetails)
        aadharXmlDataFn(userDetails)
        getDocumentByUserIdFn(userDetails)
    }

    const handleLoader = (value) => {
        setLoader(value)
    }

    const getAllUserDetailsIncompleteByUserIdFn = (data) => {
        handleLoader(true)
        getAllUserDetailsIncompleteByUserId(data?.userId, callback => {
            handleLoader(false)
            setAllData(callback)
        })
    }

    const panProfileDetailsFn = (data) => {
        handleLoader(true)
        panProfileDetails(data?.userId, callback => {
            handleLoader(false)
            setpanData(callback)
        })
    }

    const getDocumentByUserIdFn = (data) => {
        handleLoader(true)
        getDocumentByUserId(currenPage, totalItems, data?.userId, callback => {
            handleLoader(false)
            setDocumentData(callback?.data)
            setallDocuments(callback?.data)
        })
    }

    const aadharXmlDetailsFn = (data, value) => {
        handleLoader(true)
        aadharXmlDetails(data?.userId, callback => {
            handleLoader(false)
            setaadhaarAddressPopupData(callback)
            const parsedAddress = JSON.parse(callback?.address)
            setaadhaarAddressData(parsedAddress)
            setAadhaarPopup(value)
        })
    }
    const aadharXmlDataFn = (data) => {
        handleLoader(true)
        aadharXmlData(data?.userId, callback => {
            handleLoader(false)
            setaadhaarData(callback)
            if (callback?.type == "aadhaar") {
                setverificationType("XML")
            } else if (callback?.type == "digiLocker") {
                setverificationType("Digilocker")
            }
        })
    }

    const closePopup = () => {
        setPanPopup(false)
        setAadhaarPopup(false)
        handleEditdata(false, "", "")
        ApicallFn()
    }

    const handleAadhaarPanPopup = (value, type) => {
        if (type == "pan") {
            setPanPopup(value)
        }
        else if (type == "aadhaar") {
            aadharXmlDetailsFn(userDetails, value)
        }
    }

    const handleDocumentSelected = (e) => {
        const value = e.target.value;
        const ar = allDocuments?.filter((el) => el?.documentUrl === value)
        setSelectedDocument(ar[0])
    }

    const handleEditdata = (show, EditType, EditData) => {
        setEditData({ show: show, type: EditType, data: EditData })
    }

    const handleTextPopup = (type = false, text = "") => {
        setpopups({ show: type, popupStatus: text })
    }

    const closeTextPopup = () => {
        setTimeout(() => {
            handleTextPopup()
        }, 5000)
    }

    return (
        <>

            {
                loader ? <Loader /> : ''
            }
            {
                popups?.show ? <Popup popupStatus={popups?.popupStatus} closePopup={handleTextPopup} /> : ''
            }

            {
                panPopup ?
                    <KarzaPOPUPUI userDetail={userDetails} karzaData={panData} closePopup={closePopup} customStyle={customStylePopup} />
                    : ''}
            {
                aadhaarPopup ?
                    <AAdharPopup addressData={aadhaarAddressData} karzaData={aadhaarAddressPopupData} closePopup={closePopup} verificationType={verificationType} customStyle={customStylePopup} />
                    : ''}

            {
                editdata?.show ?
                    editdata?.type == "personal" ?
                        <EditPersonalDetail data={editdata?.data}
                            closePopup={closePopup}
                            customStyle={customStylePopup}
                            handleLoader={handleLoader}
                            handleTextPopup={handleTextPopup}
                            closeTextPopup={closeTextPopup}
                        />
                        :
                        editdata?.type == "basic" ?
                            <EditBasicDetail data={editdata?.data}
                                closePopup={closePopup}
                                customStyle={customStylePopup}
                                handleLoader={handleLoader}
                                handleTextPopup={handleTextPopup}
                                closeTextPopup={closeTextPopup}
                            />
                            :
                            editdata?.type == "currentAddress" ?
                                <EditCurrentAddressDetail data={editdata?.data}
                                    closePopup={closePopup}
                                    customStyle={customStylePopup}
                                    handleLoader={handleLoader}
                                    handleTextPopup={handleTextPopup}
                                    closeTextPopup={closeTextPopup}
                                />
                            :
                            editdata?.type == "permanentAddress" ?
                                <EditPermanentAddressDetail data={editdata?.data}
                                    closePopup={closePopup}
                                    customStyle={customStylePopup}
                                    handleLoader={handleLoader}
                                    handleTextPopup={handleTextPopup}
                                    closeTextPopup={closeTextPopup}
                                />
                            :
                            editdata?.type == "vehicle" ?
                                <EditAssetVehicleDetail data={editdata?.data}
                                    closePopup={closePopup}
                                    customStyle={customStylePopup}
                                    handleLoader={handleLoader}
                                    handleTextPopup={handleTextPopup}
                                    closeTextPopup={closeTextPopup}
                                />
                            :
                            editdata?.type == "employment" ?
                                <EditEmploymentDetail data={editdata?.data}
                                    closePopup={closePopup}
                                    customStyle={customStylePopup}
                                    handleLoader={handleLoader}
                                    handleTextPopup={handleTextPopup}
                                    closeTextPopup={closeTextPopup}
                                />
                            :
                            editdata?.type == "account" ?
                                <EditAccountDetail data={editdata?.data}
                                    closePopup={closePopup}
                                    customStyle={customStylePopup}
                                    handleLoader={handleLoader}
                                    handleTextPopup={handleTextPopup}
                                    closeTextPopup={closeTextPopup}
                                />
                            :
                            editdata?.type == "document" ?
                                <EditDouemntsDetails data={editdata?.data}
                                    closePopup={closePopup}
                                    customStyle={customStylePopup}
                                    handleLoader={handleLoader}
                                    handleTextPopup={handleTextPopup}
                                    closeTextPopup={closeTextPopup}
                                     allDocuments={allDocuments}
                                />
                                :
                                ''
                    : ''}

            <EditUserDetailsNew
                
                allData={allData}
                handleAadhaarPanPopup={handleAadhaarPanPopup}
                panData={panData}
                aadhaarData={aadhaarData}
                documentData={documentData}
                selectedDocument={selectedDocument}
                handleDocumentSelected={handleDocumentSelected}
                handleEditdata={handleEditdata}
                allDocuments={allDocuments}
                viewType={viewType}
            />
        </>
    )
}
